<template>
  <v-navigation-drawer
    v-model="dialog"
    absolute
    right
    temporary
    style="width: 750px;"
  >
    <update-modal
      :visible="updateDialog"
      :onConfirm="updateAssociation"
      :engines="availableEngines"
      :currentEngineName="engineName"
      @update:visible="updateDialog = $event"
    />

    <div class="pa-4">
      <v-card-title class="text-h5">
        Detalhes do conjunto {{ pumpMotoDetails ? pumpMotoDetails.id : '' }}
      </v-card-title>

      <v-card-text class="mt-2" v-if="pumpMotoDetails">
        <div class="d-flex justify-space-between mb-2">
          <div>
            <p class="text-justify">
              Empresa: {{ pumpDetails.companyName }}
            </p>

            <p class="text-justify">
              Levante: {{ pumpDetails.placeName }}
            </p>

            <p class="text-justify">
              Bomba: {{ pumpDetails.name }}
            </p>

            <p class="text-justify">
              ID da bomba: {{ pumpDetails.id }}
            </p>

            <p class="text-justify">
              Motor: {{ pumpMotoDetails ? pumpMotoDetails.EngineName : '--' }}
            </p>

            <p class="text-justify">
              ID do motor: {{ pumpMotoDetails ? pumpMotoDetails.EngineID : '--' }}
            </p>
          </div>

          <div>
            <p class="text-justify">
              Controlado Remotamente:
              <v-icon v-if="pumpMotoDetails.remoteControl" color="green">mdi-check-circle-outline</v-icon>
              <v-icon v-else color="red">mdi-close-circle-outline</v-icon>
            </p>

            <p class="text-justify">
              Monitoramento de Energia:
              <v-icon v-if="pumpMotoDetails.energyMonitoring" color="green">mdi-check-circle-outline</v-icon>
              <v-icon v-else color="red">mdi-close-circle-outline</v-icon>
            </p>

            <p class="text-justify">
              Em uso:
              <v-icon v-if="pumpMotoDetails.inUseSet" color="green">mdi-check-circle-outline</v-icon>
              <v-icon v-else color="red">mdi-close-circle-outline</v-icon>
            </p>

            <p class="text-justify">
              Status: {{ pumpMotoDetails.Status === 1 ? "Ativo" : "Inativo" }}
            </p>

            <p class="text-justify">
              Criado em: {{ dayjs(pumpMotoDetails.createdDate).format("DD/MM/YYYY HH:mm") }}
            </p>

            <p class="text-justify">
              Atualizado em: {{ dayjs(pumpMotoDetails.updatedDate).format("DD/MM/YYYY HH:mm") }}
            </p>
          </div>
        </div>

        <v-card-actions class="justify-end">
          <v-btn
            @click="toggleUpdateDialog"
            class="px-2 mr-3"
            v-if="hadPermission(3, 3)"
            elevation="2"
            outlined
            color="primary"
            small
          >
            <v-icon
              small
              color="blue"
            >mdi-pencil</v-icon>
            Editar
          </v-btn>

          <v-btn
            v-if="hadPermission(3, 4)"
            @click="_deletePumpMoto"
            class="px-2"
            elevation="2"
            color="error"
            outlined
            small
          >
            <v-icon
              small
              color="red"
            >mdi-delete</v-icon>
            Excluir
          </v-btn>
        </v-card-actions>

        <v-divider class="my-4"></v-divider>

        <pump-moto-timeline
          :fetchEvents="fetchEventsForPumpMoto"
          :pumpMoto="pumpMotoDetails"
        />

      </v-card-text>
      
      <v-card-text v-else>
        <p>Esta bomba não faz parte de um conjunto</p>
        <v-btn
          v-if="!pumpFormEnabled"
          small
          elevation="2"
          color="primary"
          @click="addPump"
        >
          Adicionar motor
        </v-btn>

        <div v-else>
          <engine-selector
            :engines="availableEngines"
            :onChange="onChangeEngine"
          />

          <v-btn
            small
            elevation="2"
            color="primary"
            @click="associate"
            :disabled="!Boolean(engineName)"
          >
            Salvar
          </v-btn>
        </div>

      </v-card-text>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { axosInstance } from "@/di/axios_instance_di";

import { STATUS } from '@/module/pump_moto/domain/model/pump_moto'

import EngineSelector from './EngineSelector.vue'
import PumpMotoTimeline from './PumpMotoTimeline.vue'
import UpdateModal from './UpdateModal.vue'

export default {
  name: 'PumpMotoDetailsModal',
  components: {
    UpdateModal,
    EngineSelector,
    PumpMotoTimeline
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    onAssociateEngine: {
      type: Function,
      default: () => null
    },
    onUpdateAssociation: {
      type: Function,
      default: () => null
    },
    onDeletePumpMoto: {
      type: Function,
      default: () => null
    },
    fetchEventsForPumpMoto: {
      type: Function,
      required: true,
      default: () => null
    },
    engines: {
      type: Array,
      default: []
    },
    pumpDetails: {
      type: Object,
      default: null
    },
    pumpMotoDetails: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      pumpFormEnabled: false,
      updateDialog: false,
      pumpMotoStatus: STATUS.ACTIVE,
      engineName: ''
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        // TODO: find a better way to cleanup the form
        this.pumpFormEnabled = false

        this.$emit('input', value);
      }
    },
    availableEngines() {
      // TODO: improve this validations!
      if (!this.engines || !this.pumpDetails) return []

      const result = this.engines.filter(engine => (
        (engine.company_id === this.pumpDetails.companyID) &&
        (engine.place_id === this.pumpDetails.placeID)
      ))

      return result
    }
  },
  methods: {
    close() {
      this.dialog = false;
    },
    toggleUpdateDialog() {
      this.updateDialog = !this.updateDialog
    },
    _deletePumpMoto() {
      this.onDeletePumpMoto(this.pumpMotoDetails)
    },
    addPump() {
      this.pumpFormEnabled = true
    },
    async updateAssociation({ engineName }) {
      await this.onUpdateAssociation({ engineName })

      this.toggleUpdateDialog()
    },
    associate() {
      this.onAssociateEngine(this.engineName)
    },
    onChangeEngine(name) {
      this.engineName = name
    }
  },
  watch: {
    pumpMotoDetails: function (value) {
      if (!value) {
        this.engineName = ''
        this.pumpMotoStatus = STATUS.ACTIVE

        return
      }

      if (value.Status != null) this.pumpMotoStatus = value.Status
      this.engineName = value.EngineName
    }
  }
}
</script> 
